import Splide from '@splidejs/splide/dist/js/splide.min';
import '@splidejs/splide/css';

document.addEventListener( 'DOMContentLoaded', function() {

	let el_bodys = document.getElementsByTagName('body');

	// トップページのみ使用する
	if (el_bodys[0].classList.contains("home")) {

		// メイン・ビジュアル
		const options_vidual = {
			// padding: "10vw",
			gap: "1rem",
			type: 'loop',
			autoplay: true,
			interval: 3000,
			focus: "center",
			arrows: false,
			pagination: false
		}
		new Splide('#splide_visual', options_vidual).mount();

		// バナー・スライド
		const options_banner = {
			perPage: 2,
			perMove: 1,
			gap: 24,
			focus: 'center',
			padding: "5rem",
			arrows: false,
			pagination: false,
			breakpoints: {
				576: {
					perPage: 1,
				},
				768: {
					perPage: 2,
				},
			},
		}
		new Splide('#splide_banner', options_banner).mount();
	}
});